<template>
    <a-result :title="$t('user.security.tfa.step_3.title')" :sub-title="$t('user.security.tfa.step_3.sub_title')">
        <template #icon>
            <CopyOutlined class="icon-color" />
        </template>
        <template #extra>
            <div class="text-left">
                <a-alert
                    :message="$t('user.notifications.info.tfa_recovery_codes_title')"
                    :description="$t('user.notifications.info.tfa_recovery_codes_description')"
                    type="warning"
                    show-icon
                />
            </div>
            <div class="text-left p-8">
                <ul class="list-disc list-inside" data-cy="recovery-codes-list">
                    <template v-for="code in tfa_recovery_codes" :key="code">
                        <li>
                            {{ code }}
                        </li>
                    </template>
                </ul>
            </div>

            <div class="text-left">
                <a-button @click="downloadRecoveryCodes" data-cy="tfa-download-codes-button">
                    {{ $t('user.security.tfa.download') }}
                </a-button>
            </div>

            <div class="text-right pt-8">
                <a-button
                    v-if="!tfa_enforced"
                    type="primary"
                    @click="enableTFA"
                    :loading="tfa_processing"
                    data-cy="tfa-next-step-3-button"
                >
                    {{ $t('user.security.tfa.enable') }}
                </a-button>
                <a-button
                    v-if="tfa_enforced"
                    type="primary"
                    @click="completeTFA"
                    :loading="tfa_processing"
                    data-cy="tfa-next-step-3-button"
                >
                    {{ $t('user.security.tfa.complete') }}
                </a-button>
            </div>
        </template>
    </a-result>
</template>

<script>
import { CopyOutlined } from '@ant-design/icons-vue';

export default {
    components: { CopyOutlined },
    props: {
        tfa_enforced: {
            type: Boolean,
            default: false,
        },
        tfa_recovery_codes: {
            type: Array,
            default: [],
        },
        tfa_processing: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        downloadRecoveryCodes() {
            this.$emit('downloadRecoveryCodes');
        },
        enableTFA() {
            this.$emit('enableTFA');
        },
        completeTFA() {
            this.$emit('completeTFA');
        },
    },
};
</script>
